define("media/components/media/table/meta-data", ["exports", "@ember/component", "@ember/object", "@ember/object/computed", "@ember/utils", "@glimmer/component", "moment-timezone", "later/utils/constants", "@ember/template-factory"], function (_exports, _component, _object, _computed, _utils, _component2, _momentTimezone, _constants, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/utils",0,"@glimmer/component",0,"moment-timezone",0,"later/utils/constants",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <tr>
    {{! Checkbox }}
    <td class="cMT--td--checkbox">
      <span {{on "click" this.toggleSelection}}>
        {{#if this.isSelected}}
          {{svg-jar "verified" class="o--icon--md o--icon--light o--table__checkbox cMT--meta__selectAll is--checked"}}
        {{else}}
          {{svg-jar "verified" class="o--icon--md o--icon--light o--table__checkbox cMT--meta__selectAll"}}
        {{/if}}
      </span>
    </td>
    {{! Image }}
    <td class="cMT--td--image u--p__lr__0" {{on "click" this.openMediaItem}}>
      <img class="o--media" src={{@mediaItem.mediaLibraryImageUrl}} />
      {{#if @mediaItem.isVideo}}
        <span class="o--media__label--type">
          {{svg-jar "video" class="o--icon--sm o--icon--white u--m__t__xs"}}
        </span>
      {{/if}}
    </td>
    {{! Starred }}
    <td class="cMT--td--starred u--p__l__sm">
      <span class="u--pointer" {{on "click" this.toggleStarred}}>
        {{#if @mediaItem.isStarred}}
          {{svg-jar "starred" class="o--icon--md o--icon--yellow"}}
        {{else}}
          {{svg-jar "star" class="o--icon--md o--icon--light"}}
        {{/if}}
      </span>
    </td>
    {{! Name }}
    <td class="cMT--td--name" {{on "click" this.openMediaItem}}>
      <p class="u--ellipsis u--m__b__0">
        {{@mediaItem.originalFilename}}
        <EmberTooltip @delay={{330}} @side="right">
          {{@mediaItem.originalFilename}}
        </EmberTooltip>
      </p>
    </td>
    {{! Labels }}
    <td class="cMT--td--labels {{if this.labelsMatchQuery 'is--highlighted'}}" {{on "click" this.openMediaItem}}>
      <p class="u--ellipsis u--m__tb__sm">
        {{#each this.firstTwoLabels as |metaLabel|}}
          <span class="cLB--label--sm {{if metaLabel.isSystemLabel 'cLB--label--system'}}">
            {{metaLabel.shortTagName}}
          </span>
        {{/each}}
        {{#if this.hasMoreThanTwoLabels}}
          <span class="cLB--label--sm cLB--label--system {{this.dropdownTargetClass}}">
            {{svg-jar "ellipsis-h-solid" class="o--icon--xs o--icon--light"}}
          </span>
          <Shared::Ui::EmberDrop
            @constrainToScrollParent={{true}}
            @constrainToWindow={{true}}
            @contentSelector={{this.dropdownContentClassAsSelector}}
            @openOn="hover"
            @position="bottom right"
            @target={{this.dropdownTargetClassAsSelector}}
          >
            <div class="o--dropWrapper u--slideDown {{this.dropdownContentClass}}">
              <div class="o--dropBody">
                {{#each this.restOfLabels as |metaLabel|}}
                  <span class="cLB--label {{if metaLabel.isSystemLabel 'cLB--label--system'}}">
                    {{metaLabel.canonicalTagName}}
                  </span>
                {{/each}}
              </div>
            </div>
          </Shared::Ui::EmberDrop>
        {{/if}}
      </p>
    </td>
    {{! Notes }}
    <td class="cMT--td--notes {{if this.notesMatchQuery 'is--highlighted'}}" {{on "click" this.openMediaItem}}>
      <p class="u--ellipsis u--m__b__0">
        {{this.trimmedMediaNotes}}
      </p>
    </td>
    {{! Post Count }}
    <td class="cMT--td--count u--text--center" {{on "click" this.openMediaItem}}>
      <p class="u--ellipsis u--m__b__0">
        {{@mediaItem.postCount}}
      </p>
    </td>
    {{! Upload Date }}
    <td class="cMT--td--date" {{on "click" this.openMediaItem}}>
      <p class="u--ellipsis u--m__b__0">
        {{format-date this.mediaItemUploadDate}}
      </p>
    </td>
    {{! Size }}
    <td class="cMT--td--size" {{on "click" this.openMediaItem}}>
      <p class="u--ellipsis u--m__b__0">
        <span class="u--block">
          {{this.mediaItemFileSize}}
        </span>
        <span class="u--block u--text--light">
          {{this.mediaItemDimensions}}
        </span>
      </p>
    </td>
  </tr>
  */
  {
    "id": "2XEvbnuN",
    "block": "[[[10,\"tr\"],[12],[1,\"\\n\"],[1,\"  \"],[10,\"td\"],[14,0,\"cMT--td--checkbox\"],[12],[1,\"\\n    \"],[11,1],[4,[38,0],[\"click\",[30,0,[\"toggleSelection\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"isSelected\"]],[[[1,\"        \"],[1,[28,[35,2],[\"verified\"],[[\"class\"],[\"o--icon--md o--icon--light o--table__checkbox cMT--meta__selectAll is--checked\"]]]],[1,\"\\n\"]],[]],[[[1,\"        \"],[1,[28,[35,2],[\"verified\"],[[\"class\"],[\"o--icon--md o--icon--light o--table__checkbox cMT--meta__selectAll\"]]]],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[1,\"  \"],[11,\"td\"],[24,0,\"cMT--td--image u--p__lr__0\"],[4,[38,0],[\"click\",[30,0,[\"openMediaItem\"]]],null],[12],[1,\"\\n    \"],[10,\"img\"],[14,0,\"o--media\"],[15,\"src\",[30,1,[\"mediaLibraryImageUrl\"]]],[12],[13],[1,\"\\n\"],[41,[30,1,[\"isVideo\"]],[[[1,\"      \"],[10,1],[14,0,\"o--media__label--type\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"video\"],[[\"class\"],[\"o--icon--sm o--icon--white u--m__t__xs\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[1,\"  \"],[10,\"td\"],[14,0,\"cMT--td--starred u--p__l__sm\"],[12],[1,\"\\n    \"],[11,1],[24,0,\"u--pointer\"],[4,[38,0],[\"click\",[30,0,[\"toggleStarred\"]]],null],[12],[1,\"\\n\"],[41,[30,1,[\"isStarred\"]],[[[1,\"        \"],[1,[28,[35,2],[\"starred\"],[[\"class\"],[\"o--icon--md o--icon--yellow\"]]]],[1,\"\\n\"]],[]],[[[1,\"        \"],[1,[28,[35,2],[\"star\"],[[\"class\"],[\"o--icon--md o--icon--light\"]]]],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[1,\"  \"],[11,\"td\"],[24,0,\"cMT--td--name\"],[4,[38,0],[\"click\",[30,0,[\"openMediaItem\"]]],null],[12],[1,\"\\n    \"],[10,2],[14,0,\"u--ellipsis u--m__b__0\"],[12],[1,\"\\n      \"],[1,[30,1,[\"originalFilename\"]]],[1,\"\\n      \"],[8,[39,3],null,[[\"@delay\",\"@side\"],[330,\"right\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[30,1,[\"originalFilename\"]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[1,\"  \"],[11,\"td\"],[16,0,[29,[\"cMT--td--labels \",[52,[30,0,[\"labelsMatchQuery\"]],\"is--highlighted\"]]]],[4,[38,0],[\"click\",[30,0,[\"openMediaItem\"]]],null],[12],[1,\"\\n    \"],[10,2],[14,0,\"u--ellipsis u--m__tb__sm\"],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"firstTwoLabels\"]]],null]],null],null,[[[1,\"        \"],[10,1],[15,0,[29,[\"cLB--label--sm \",[52,[30,2,[\"isSystemLabel\"]],\"cLB--label--system\"]]]],[12],[1,\"\\n          \"],[1,[30,2,[\"shortTagName\"]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[2]],null],[41,[30,0,[\"hasMoreThanTwoLabels\"]],[[[1,\"        \"],[10,1],[15,0,[29,[\"cLB--label--sm cLB--label--system \",[30,0,[\"dropdownTargetClass\"]]]]],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"ellipsis-h-solid\"],[[\"class\"],[\"o--icon--xs o--icon--light\"]]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,6],null,[[\"@constrainToScrollParent\",\"@constrainToWindow\",\"@contentSelector\",\"@openOn\",\"@position\",\"@target\"],[true,true,[30,0,[\"dropdownContentClassAsSelector\"]],\"hover\",\"bottom right\",[30,0,[\"dropdownTargetClassAsSelector\"]]]],[[\"default\"],[[[[1,\"\\n          \"],[10,0],[15,0,[29,[\"o--dropWrapper u--slideDown \",[30,0,[\"dropdownContentClass\"]]]]],[12],[1,\"\\n            \"],[10,0],[14,0,\"o--dropBody\"],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"restOfLabels\"]]],null]],null],null,[[[1,\"                \"],[10,1],[15,0,[29,[\"cLB--label \",[52,[30,3,[\"isSystemLabel\"]],\"cLB--label--system\"]]]],[12],[1,\"\\n                  \"],[1,[30,3,[\"canonicalTagName\"]]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[3]],null],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[1,\"  \"],[11,\"td\"],[16,0,[29,[\"cMT--td--notes \",[52,[30,0,[\"notesMatchQuery\"]],\"is--highlighted\"]]]],[4,[38,0],[\"click\",[30,0,[\"openMediaItem\"]]],null],[12],[1,\"\\n    \"],[10,2],[14,0,\"u--ellipsis u--m__b__0\"],[12],[1,\"\\n      \"],[1,[30,0,[\"trimmedMediaNotes\"]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[1,\"  \"],[11,\"td\"],[24,0,\"cMT--td--count u--text--center\"],[4,[38,0],[\"click\",[30,0,[\"openMediaItem\"]]],null],[12],[1,\"\\n    \"],[10,2],[14,0,\"u--ellipsis u--m__b__0\"],[12],[1,\"\\n      \"],[1,[30,1,[\"postCount\"]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[1,\"  \"],[11,\"td\"],[24,0,\"cMT--td--date\"],[4,[38,0],[\"click\",[30,0,[\"openMediaItem\"]]],null],[12],[1,\"\\n    \"],[10,2],[14,0,\"u--ellipsis u--m__b__0\"],[12],[1,\"\\n      \"],[1,[28,[35,7],[[30,0,[\"mediaItemUploadDate\"]]],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[1,\"  \"],[11,\"td\"],[24,0,\"cMT--td--size\"],[4,[38,0],[\"click\",[30,0,[\"openMediaItem\"]]],null],[12],[1,\"\\n    \"],[10,2],[14,0,\"u--ellipsis u--m__b__0\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--block\"],[12],[1,\"\\n        \"],[1,[30,0,[\"mediaItemFileSize\"]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,1],[14,0,\"u--block u--text--light\"],[12],[1,\"\\n        \"],[1,[30,0,[\"mediaItemDimensions\"]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@mediaItem\",\"metaLabel\",\"metaLabel\"],false,[\"on\",\"if\",\"svg-jar\",\"ember-tooltip\",\"each\",\"-track-array\",\"shared/ui/ember-drop\",\"format-date\"]]",
    "moduleName": "media/components/media/table/meta-data.hbs",
    "isStrictMode": false
  });
  let MetaDataComponent = _exports.default = (_dec = (0, _computed.sort)('mediaLabels', 'labelSorting'), (_class = class MetaDataComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "sortedMediaLabels", _descriptor, this);
      _defineProperty(this, "labelSorting", ['taggedCount:desc']);
    }
    get dropdownContentClass() {
      return 'e--metadataFilter--toggle' + this.args.mediaItem.id;
    }
    get dropdownContentClassAsSelector() {
      return '.' + this.dropdownContentClass;
    }
    get dropdownTargetClass() {
      return 'e--metadataFilter--drop' + this.args.mediaItem.id;
    }
    get dropdownTargetClassAsSelector() {
      return '.' + this.dropdownTargetClass;
    }
    get firstTwoLabels() {
      return this.sortedMediaLabels.slice(0, 2);
    }
    get hasMoreThanTwoLabels() {
      return this.sortedMediaLabels.length > 2;
    }
    get isSelected() {
      return this.args.selectedAssets.includes(this.args.mediaItem);
    }
    get labelsMatchQuery() {
      return this.mediaLabels.any(mediaLabel => !!this.args.queryLabels?.includes(mediaLabel));
    }
    get mediaItemDimensions() {
      if (!(0, _utils.isEmpty)(this.args.mediaItem.width) && !(0, _utils.isEmpty)(this.args.mediaItem.height)) {
        return this.args.mediaItem.width + 'X' + this.args.mediaItem.height;
      }
      return null;
    }
    get mediaItemFileSize() {
      if (!(0, _utils.isEmpty)(this.args.mediaItem.fileSize)) {
        const fileSizeKB = this.args.mediaItem.fileSize / 1024;
        if (fileSizeKB > 1024) {
          return (fileSizeKB / 1024).toFixed(2) + ' MB';
        }
        return fileSizeKB.toFixed(2) + ' KB';
      }
      return null;
    }
    get mediaItemUploadDate() {
      return (0, _utils.isEmpty)(this.args.mediaItem.createdTime) ? null : _momentTimezone.default.unix(this.args.mediaItem.createdTime);
    }
    get mediaLabels() {
      return this.args.mediaItem.labels;
    }
    get notesMatchQuery() {
      if (!(0, _utils.isEmpty)(this.args.searchString)) {
        const query = this.args.searchString.toLowerCase();
        const mediaNotes = this.args.mediaItem.defaultCaption.toLowerCase();
        return mediaNotes.indexOf(query) > -1;
      }
      return null;
    }
    get restOfLabels() {
      return this.sortedMediaLabels.slice(2);
    }
    get trimmedMediaNotes() {
      // This method probably doesn't work correctly for non-English characters... must fix the table(s) situation
      return this.args.mediaItem.defaultCaption.length >= _constants.MEDIA_ITEMS_LIMIT ? this.args.mediaItem.defaultCaption.slice(0, 27) + '...' : this.args.mediaItem.defaultCaption;
    }
    openMediaItem() {
      if (!this.args.mediaItem.isUploading) {
        this.args.openAssetModal(this.args.mediaItem);
      }
    }
    toggleSelection() {
      if (this.isSelected) {
        this.args.removeSelection(this.args.mediaItem);
      } else {
        this.args.addSelection(this.args.mediaItem);
      }
    }
    toggleStarred() {
      if (this.args.mediaItem.isStarred) {
        this.args.removeStarred(this.args.mediaItem);
      } else {
        this.args.addStarred(this.args.mediaItem);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "sortedMediaLabels", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "openMediaItem", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openMediaItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSelection", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSelection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleStarred", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleStarred"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MetaDataComponent);
});